
import Vue from 'vue'
import { accounts } from '@/assets/menu'
import { ICardProps } from '@/entities/Card'
import UserEntity, { IUserProps } from '@/entities/User'
import MenuEntity, { IMenuProps } from '@/entities/Menu'
import { PaymentType } from '@/constants/PaymentType'

const component = Vue.extend({
  data() {
    return {
      accounts
    }
  },
  async fetch() {
    if (this.App.user.current?.payments?.type === PaymentType.Credit) {
      await this.App.payment.fetch(this.App)
    }
  },
  computed: {
    __accounts(): IMenuProps[] {
      return this.accounts
    },
    cards(): ICardProps[] {
      return this.App.payment.data || []
    },
    isCardExpired(): boolean {
      if (this.App.user.current?.payments?.type !== PaymentType.Credit) return false
      const cards = this.cards
      if (cards && cards.length > 0) {
        const now = new Date()
        const currentYear = parseInt(now.getFullYear().toString().slice(-2))
        const currentMonth = now.getMonth() + 1
        const defaultCard = cards.find((card: ICardProps) => card.defaultFlag === '1')
        if (defaultCard) {
          const expYear = parseInt(defaultCard.expire.slice(0, 2))
          const expMonth = parseInt(defaultCard.expire.slice(2, 4))
          // 現在の年が有効期限の年より大きい場合は期限切れ
          if (currentYear > expYear) return true
          // 現在と有効期限の年が等しく、現在の月が有効期限の月を過ぎた場合（現在の月が有効期限の月より大きい場合）は期限切れ
          if (currentYear === expYear && currentMonth > expMonth) return true
        }
        return false
      }
      return false
    }
  },
  methods: {
    u(value?: IUserProps): UserEntity {
      return new UserEntity(value)
    },
    m(value?: IMenuProps): MenuEntity {
      return new MenuEntity(value)
    }
  }
})

Vue.component('MAppAccount', component)
export default component
